import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { TouristSign } from '../../models/serializable/tourist-sign.js';
import { fromEnumAsString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class TouristSignComponent extends Component {
  static readonly TYPE_ID: string = 'b9b5e761c41b4164b3afcc0e3a4b8c21';

  constructor(
    public readonly touristSign: TouristSign,
  ) {
    super();
  }

  get $typeId() {
    return TouristSignComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): TouristSignComponent {
    return new TouristSignComponent(
        MapUtils.get<TouristSign>(map, 'touristSign'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'touristSign': fromEnumAsString(this.touristSign),
    };
  }

  clone(): this {
    return new TouristSignComponent(
        this.touristSign,
    ) as this;
  }

  isSame(other: TouristSignComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.touristSign === this.touristSign;
  }
}

export class TouristSignComponentBuilder extends DataModelBuilder<TouristSignComponent> {
  build(context: SerializationContext, map: SerializedData): TouristSignComponent {
    return TouristSignComponent.fromMap(context, map);
  }
}
